import React, { useEffect, useState, useRef } from "react"
import { helper, http, notify } from "../../../util"
import Form from "../../_lib/form/form"
import Textbox from "../../_lib/input/textbox"

const LoginForm = ({ inquiryFormState, handleInquirySubmit, showLoginFormSetter, userIdSetter }) => {

    const initialUserPass = {
        UserName: '',
        Password: '',
        RememberMe: false,
    }

    const initialOneTimePassword = {
        Password: '',
        IsSent: false
    }

    const userPassFormRef = useRef();
    const oneTimePasswordFormRef = useRef();
    const [showUsernameForm, setShowUsernameForm] = useState(true);
    const [userPassFormState, setUserPassFormState] = useState(initialUserPass);
    const [passIsReady, setPassIsReady] = useState(false);
    const [oneTimePassword, setOneTimePassword] = useState(initialOneTimePassword);
    const [oneTimePasswordIsReady, setOneTimePasswordIsReady] = useState(false);

    const getFormRows = () => {
        let rows = [],
            cols = []

        cols.push({
            className: "",
            items: [
                {
                    type: "textbox",
                    name: "UserName",
                    label: "نام کاربری (شماره همراه)",
                    defaultValue: "",
                    required: true,
                    attr: { "data-checkify": "required" },
                },
            ],
        })

        rows.push({ cols })
        cols = []

        return rows
    }

    const CheckUser = async (data) => {
        const dataObj = JSON.parse(await data.get("Data").text())
        setUserPassFormState((oldState) => ({ ...oldState, UserName: dataObj.UserName }));

        await http.post(
            helper.getApiPath("Security", "CheckUser"),
            dataObj
        ).then((res) => {
            let UserIsRegistered = JSON.parse(res.response).UserIsRegistered
            setShowUsernameForm(false)

            if (!UserIsRegistered) {
                sendOneTimePassword(dataObj.UserName)
                setOneTimePassword((oldState) => ({ ...oldState, IsSent: true }))
            }
        })
    }

    const Login = async () => {
        const res = await http.post(
            helper.getApiPath("Security", "Login"),
            userPassFormState
        );

        if (res.responseText == 0) {
            notify.show({
                message: "رمز عبور وارد شده صحیح نمی باشد",
                type: "error",
            })
        }

        if (res.responseText == 1 || res.responseText == 2) {
            handleInquirySubmit(inquiryFormState);
            showLoginFormSetter(false);
        }
    }

    const LoginWithOneTimePassword = async () => {
        let res = await http.post(
            helper.getApiPath("Verification", "LoginWithOneTimePassword"),
            { Username: userPassFormState.UserName, Code: oneTimePassword.Password, RememberMe: userPassFormState.RememberMe }
        );
        res = JSON.parse(res.responseText)
        if (res.didLogIn) {
            handleInquirySubmit(inquiryFormState);
            showLoginFormSetter(false);
            if (res.isNewUser) {
                let data = {
                    UserID: res.UserID,
                    FirstName: inquiryFormState.FirstName,
                    LastName: inquiryFormState.LastName,
                    Mobile: userPassFormState.UserName,
                    UserType: 1
                };
                await http.post(`${process.env.REACT_APP_FARASHOP_API_ROOT}/UserProfile/CreateProfile`, data)
            }
        }
        else if (res.isValidCode === false)
            notify.show({ message: "کد وارد شده معتبر نمی باشد", type: "error" })
    }

    const sendOneTimePassword = async (username) => {
        await http.get(
            helper.getApiPath("Verification", "Send4OneTimePassword"),
            username
        ).then((res) => {
            res = JSON.parse(res.responseText)
            if (res?.Status === 1)
                setOneTimePassword((oldState) => ({ ...oldState, IsSent: true }));
            else if (res?.Status === 2)
                notify.show({ message: "شماره همراه وارد شده در سایت ثبت نام نکرده است", type: "error" })
            else if (res?.status === 3)
                notify.show({ message: "کد ارسال شده قبلی هنوز منقضی نشده است", type: "error" })
            else
                notify.show({ message: "ارسال کد یک بار مصرف با خطا مواجه شد", type: "error" })
        })
    }

    useEffect(() => {
        $(userPassFormRef.current).checkify({
            message: {
                position: "right",
                required: "پر کردن این فیلد الزامی است.",
                regex: "فرمت اطلاعات وارد شده صحیح نیست.",
                between: "فرمت اطلاعات وارد شده صحیح نیست.",
                number: "در این فیلد فقط می توانید عدد وارد کنید.",
                maxlen: "بیشترین تعداد کاراکتر مجاز {count} است.",
                minlen: "کمترین تعداد کاراکتر مجاز {count} است.",
            },
            onValid: (e) => {
                e.preventDefault();
                setPassIsReady(true);
            },
            onError: () => {
                if (passIsReady)
                    setPassIsReady(false);
                console.error(userPassFormState)
            },
        })
    }, [userPassFormState]);

    useEffect(() => {
        $(oneTimePasswordFormRef.current).checkify({
            message: {
                position: "right",
                required: "پر کردن این فیلد الزامی است.",
                regex: "فرمت اطلاعات وارد شده صحیح نیست.",
                between: "فرمت اطلاعات وارد شده صحیح نیست.",
                number: "در این فیلد فقط می توانید عدد وارد کنید.",
                maxlen: "بیشترین تعداد کاراکتر مجاز {count} است.",
                minlen: "کمترین تعداد کاراکتر مجاز {count} است.",
            },
            onValid: (e) => {
                e.preventDefault();
                setOneTimePasswordIsReady(true);
            },
            onError: () => {
                if (oneTimePasswordIsReady)
                    setOneTimePasswordIsReady(false);
                console.error(oneTimePassword)
            },
        })
    }, [oneTimePassword]);

    useEffect(() => {
        if (passIsReady) {
            Login()
            setPassIsReady(false);
        }
    }, [passIsReady]);

    useEffect(() => {
        if (oneTimePasswordIsReady) {
            //if (userIsRegistered)
            LoginWithOneTimePassword()
            // else
            //     SignupWithOneTimePassword()
            setOneTimePasswordIsReady(false)
        }
    }, [oneTimePasswordIsReady]);

    return (
        <>
            <div className="user">
                <div className="user__spinner"></div>
                <div className="user__wrapper">
                    <div className="user__login panel panel-default">
                        <h3 className="panel-heading">ورود</h3>
                        <div className="user__formWrapper">
                            {showUsernameForm ?
                                <Form
                                    rows={getFormRows()}
                                    onSubmit={CheckUser}
                                    submitButtonText="تایید"
                                /> :
                                <>
                                    {oneTimePassword.IsSent ?
                                        <form ref={oneTimePasswordFormRef} className="padding-wrapper">
                                            <div className="btn-back-cn">
                                                <div
                                                    className="btn-back"
                                                    onClick={() => {
                                                        setOneTimePassword((oldState) => ({ ...oldState, IsSent: false }));
                                                        setShowUsernameForm(true)
                                                    }}>
                                                    <i className="fa fa-arrow-right"></i>
                                                </div>
                                            </div>
                                            <Textbox
                                                label="کد ارسالی را وارد کنید (الزامی)"
                                                name="password"
                                                value={oneTimePassword.Password}
                                                onChange={(e) => { setOneTimePassword((oldState) => ({ ...oldState, Password: e.target.value })) }}
                                                {...{ 'data-checkify': 'required', type: 'password' }}
                                            />
                                            <button className="btn otp_confirm" type="submit">تایید</button>
                                        </form>
                                        :
                                        <form ref={userPassFormRef} className="padding-wrapper">
                                            <div className="btn-back-cn">
                                                <div className="btn-back" onClick={() => setShowUsernameForm(true)}>
                                                    <i className="fa fa-arrow-right"></i>
                                                </div>
                                            </div>
                                            <Textbox
                                                label="رمز ورود (الزامی)"
                                                name="password"
                                                value={userPassFormState.Password}
                                                onChange={(e) => { setUserPassFormState((oldState) => ({ ...oldState, Password: e.target.value })) }}
                                                {...{ 'data-checkify': 'required', type: 'password' }}
                                            />
                                            <div className="remember-me-cn">
                                                <label className="rememberMe-label">
                                                    <input
                                                        type="checkbox"
                                                        name="RememberMe"
                                                        checked={userPassFormState.RememberMe}
                                                        onChange={(e) => { setUserPassFormState((oldState) => ({ ...oldState, RememberMe: e.target.checked })) }}
                                                    />
                                                    <span>مرا به خاطر بسپار</span>
                                                </label>
                                            </div>
                                            <div className="login-btn-cn">
                                                <button className="btn" type="submit">ورود</button>
                                                <div
                                                    className="btn one-time-password"
                                                    onClick={() => { sendOneTimePassword(userPassFormState.UserName) }}
                                                >
                                                    ورود با رمز یک بار مصرف
                                                </div>
                                            </div>
                                            <a target="_blank" href="/default.aspx?ctl=SendPassword">رمز ورود خود را فراموش کرده ام</a>
                                        </form>
                                    }
                                </>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default LoginForm